<template>
  <div class="initiatives">
    <h1 style="font-weight:700;">我們支持開放取用</h1>
    <h2 style="font-weight:500;">什麼是開放取用？</h2>
    <p class="txt">開放取用是一股日益成長的全球性風潮，透過網路敲開緊鎖的學術大門以及曾經鎖在裡面的知識。開放取用鼓勵與所有人不受限制地分享研究結果。開放取用的風潮來自全球，持續累積前所未有的動能，且研究資助者和政策制定者也正發揮他們的影響力，全力支持中。</p>

    <br>
    <h2 style="font-weight:500;">為什麼開放取用這麼重要呢？</h2>

    <p class="txt">「開放取用幫助科學家為人們改善健康，提供機會讓科學家的努力能夠更容易被閱讀和引用、讓研究結果和其他資源能夠整合，幫助獎勵補助機構評估他們所資助的研究，並且確保醫療的數位檔案獲得妥善保存。」--倫敦，惠康基金會執行長Mark Walport</p>
    <p class="txt">「支持且從事學術研究的大學無力支應持續上漲的期刊價格，被迫取消部分期刊的訂閱。有了開放取用，大學端就不需要切斷教授和學生取用資訊的管道，我們能夠在不增加學校經費的情況下提供知識。」--德州聖，三一大學，圖書館館員Diane J. Graves</p>
    <p class="txt">「身為中學自然科老師，我沒有資金訂閱傳統科學期刊。透過開放取用取得研究報告為衆多初出茅廬的科學家提供動機和刺激，將嘉惠未來的科學研究。」--加州，Black Pine Circle School中小學自然科老師Barbara Stebbins</p>
    <p class="txt">「積極推廣開放取用的團體是為病患爭取權益者之一。身為兩個患有罕見基因疾病孩子的母親，我發現要取用研究成果十分困難，而開放取用能幫助我更加支持我的家庭。」華盛頓特區，基因聯盟(Genetic Alliance)會長暨首席執行長，Sharon Terry</p>
    <p class="txt">「我是初級照護臨床醫生。我想要透過可取得的、最佳的研究證據來協助治療、照顧病患，而這些研究大部分都發表在醫學期刊上。在開放取用之前，這些研究通常都被鎖在付費訂閱的高牆之後。有了開放取用，我能夠更容易且廣泛地取得這些應用在治療病患上所需的研究實證。」舊金山，加州大學副教授Ida Sim</p>
    <p class="txt">「開放取用對我而言，最重要的是所提高的可發現性和可瀏覽性能夠導向更好的研究效率。良好效率能夠節省納稅人的稅金和研究者的時間，最終帶來更多、更快或者更省錢的研究發現。」賓州，賓州大學博士生，Andre Brown</p>
    <p class="txt" style="text-indent: 0em">資料來源：<a href="https://st2.ning.com/topology/rest/1.0/file/get/2865287631?profile=original">https://st2.ning.com/topology/rest/1.0/file/get/2865287631?profile=original</a></p>
  </div>
</template>
<script>
export default {
  name: 'InitiativeS'
}

</script>
<style>
/*@font-face {
  font-family: Times New Roman;
  src: url(DroidSans.woff);
  unicode-range: U+000-5FF, U+1e00-1fff, U+2000-2300;
}*/


.initiatives {
  padding: 4%;
  padding-top: 2%;
  background-color: rgba(248, 194, 88,0.1);
  box-shadow: 0 5px 5px -2px rgba(0, 0, 0, .2);
  padding-bottom: 50px;

}

h1 {
  font-weight: 700;
}

h2 {
  font-weight: 700;
}

.txt {


  font-size: 20px;
  text-align: left;
  text-indent: 2em;
  font-weight: 500;

}

</style>
